import { useState, useEffect } from "react";
import { isExperienceEditorActive } from "@sitecore-jss/sitecore-jss-react";
export const useIsInView = componentRef => {
  const isEditing = isExperienceEditorActive();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    let observer;
    if (componentRef.current && !isEditing) {
      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0 || entry.isIntersecting) {
              setIsVisible(entry.isIntersecting);
            }
          });
        }, {
          rootMargin: "0% 0% 0% 0%",
          threshold: 0.01
        });
      } else {
        setIsVisible(false);
      }
      if (observer && componentRef.current) {
        observer.observe(componentRef.current);
      }
    }
    return () => {
      if (observer && observer.unobserve && componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [componentRef]);
  return isVisible;
};